import React, { FC, useState } from 'react'
import { Alert, Button, Card, Col, Form, Modal, Row } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { IconContext } from 'react-icons'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store/store'
import { BsEraserFill, BsFillPencilFill, BsFillTrashFill, BsSave } from 'react-icons/bs'
import DSCatUbicaciones from '../../Services/Catalogos/CatUbicaciones.Services'
import { updateCatUbicaciones, deleteCatUbicaciones } from '../../store/features/Catalogos/CatUbicacionesSlice'
import ICatUbicaciones from '../../Interfaces/Catalogos/ICatUbicaciones'

interface IProps {}

export const CatUbicaciones: FC<IProps> = (props) => {
  const dispatch = useDispatch()
  const CatUbicaciones = useSelector((state: RootState) => state.CatUbicaciones.CatUbicaciones)
  const [showCatUbicacionesDialog, setShowCatUbicacionesDialog] = useState(false)
  const [deleteCatUbicacionesDialog, setDeleteCatUbicacionesDialog] = useState(false)
  const [IDUbicacion, setIDUbicacion] = useState(0)
  const [Clasificacion, setClasificacion] = useState(0)
  const [Ubicacion, setUbicacion] = useState('')
  const [Search, setSearch] = useState('')
  const columnsConcepts = [
    {
      name: 'id',
      width: '80px',
      selector: (row: ICatUbicaciones) => row.id,
      sortable: true,
    },
    {
      name: 'O / D',
      width: '80px',
      selector: (row: ICatUbicaciones) => (row.clasificacion === 1 ? 'O' : 'D'),
      sortable: true,
    },
    {
      name: 'Ubicacion',
      width: '450px',
      selector: (row: ICatUbicaciones) => row.ubicacion,
      sortable: true,
    },
    {
      name: 'Editar',
      width: '100px',
      cell: (row: ICatUbicaciones) => (
        <div
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => {
            showInfo(row)
          }}
        >
          <IconContext.Provider value={{ color: 'blue', size: '21px' }}>
            <BsFillPencilFill />
          </IconContext.Provider>
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Elimina',
      width: '100px',
      cell: (row: ICatUbicaciones) => (
        <div
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => {
            confirmDelete(row)
          }}
        >
          <IconContext.Provider value={{ color: 'red', size: '21px' }}>
            <BsFillTrashFill />
          </IconContext.Provider>
        </div>
      ),
      sortable: true,
    },
  ]

  const showInfo = (data: ICatUbicaciones) => {
    setIDUbicacion(data.id)
    setUbicacion(data.ubicacion)
    setClasificacion(data.clasificacion)
    setShowCatUbicacionesDialog(true)
  }

  const confirmDelete = (data: ICatUbicaciones) => {
    setIDUbicacion(data.id)
    setUbicacion(data.ubicacion)
    setClasificacion(data.clasificacion)
    setDeleteCatUbicacionesDialog(true)
  }

  const deleteInfo = () => {
    DSCatUbicaciones.Delete(IDUbicacion)
      .then((response) => {
        dispatch(deleteCatUbicaciones(IDUbicacion))
      })
      .catch((e: Error) => {})
    setDeleteCatUbicacionesDialog(false)
  }

  const clearForm = () => {
    setIDUbicacion(0)
    setUbicacion('')
    setClasificacion(1)
  }

  const saveInfo = () => {
    const data: ICatUbicaciones = {
      id: IDUbicacion,
      ubicacion: Ubicacion,
      clasificacion: Clasificacion,
      activo: 1,
    }
    DSCatUbicaciones.Append(data)
      .then((response) => {
        dispatch(updateCatUbicaciones(response.data))
      })
      .catch((e: Error) => {})
    setShowCatUbicacionesDialog(false)
  }

  const filtraReporte = (e: any) => {
    setSearch(e.target.value)
  }

  return (
    <div>
      <Row>
        <Col xs={12}>
          <Card style={{}}>
            <Card.Body>
              <Card.Title style={{ textAlign: 'left' }}>
                <Alert variant='primary'>Ubicacions</Alert>
              </Card.Title>
              <Row>
                <Col xs={12}>
                  <Form.Control
                    type='text'
                    size='sm'
                    placeholder='Search...'
                    onChange={(e) => {
                      filtraReporte(e)
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <DataTable
                    noHeader
                    defaultSortFieldId={'id'}
                    defaultSortAsc={true}
                    striped={true}
                    dense={true}
                    paginationPerPage={10}
                    pagination
                    highlightOnHover
                    columns={columnsConcepts}
                    data={CatUbicaciones.filter(function (row: ICatUbicaciones) {
                      return row.ubicacion.includes(Search)
                    })}
                    pointerOnHover
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal
        show={showCatUbicacionesDialog}
        onHide={() => {
          setShowCatUbicacionesDialog(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Catalogo: Ubicaciones</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={3}>No. ubicacion</Col>
            <Col xs={2}>
              <Form.Control type='text' id='IDUbicacion' value={IDUbicacion} disabled size='sm' />
            </Col>
            <Col xs={1} style={{ textAlign: 'left' }}>
              <Button
                size='sm'
                variant='white'
                onClick={() => {
                  clearForm()
                }}
              >
                <IconContext.Provider value={{ color: 'orange', size: '25px' }}>
                  <BsEraserFill />
                </IconContext.Provider>
              </Button>
            </Col>
            <Col xs={3} style={{ textAlign: 'right' }}>
              Clasificacion
            </Col>
            <Col xs={3}>
              <Form.Control
                as='select'
                onChange={(e) => {
                  setClasificacion(parseInt(e.target.value))
                }}
                value={Clasificacion}
                className='form-select form-select-sm'
              >
                <option value={1}>Origen</option>
                <option value={2}>Destino</option>
              </Form.Control>
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={2}>Ubicacion</Col>
            <Col xs={10}>
              <Form.Control
                type='text'
                id='Ubicacion'
                value={Ubicacion}
                size='sm'
                onChange={(e) => {
                  setUbicacion(e.target.value)
                }}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={2}></Col>
            <Col xs={3}>&nbsp;</Col>
            <Col xs={3}>
              <Button
                variant='primary'
                onClick={() => {
                  saveInfo()
                }}
              >
                Guarda
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
      <Modal
        show={deleteCatUbicacionesDialog}
        onHide={() => {
          setDeleteCatUbicacionesDialog(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Catalogo: Ubicaciones</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <br />
          <Row>
            <Col xs={12}>
              <Alert variant='warning'>
                ¿Esta seguro de que desea eliminar la ubicacion: <br />
                <span style={{ fontWeight: 'bold', fontSize: '20px' }}>{Ubicacion}</span>?
              </Alert>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={2}></Col>
            <Col xs={3}>&nbsp;</Col>
            <Col xs={3}>
              <Button
                variant='danger'
                onClick={() => {
                  deleteInfo()
                }}
              >
                Elimina
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
